(function () {
    'use strict';

    function removePhaseModalController($scope, $uibModalInstance, phaseIndex, phaseTitle) {
        $scope.ok = function () {
            $uibModalInstance.close(true);
        };

        $scope.cancel = function() {
            $uibModalInstance.close();
        }

        $scope.phaseIndex = phaseIndex;
        $scope.phaseTitle = phaseTitle;
    }

    removePhaseModalController.$inject = ['$scope', '$uibModalInstance', 'phaseIndex', 'phaseTitle'];

    angular.module('ecap.workflow').controller('removePhaseModalController', removePhaseModalController);
})();
